<template>
    <div class="d-flex flex-column align-items-center justify-content-center spinner" :class="[spinnerCircle ? 'spinner-circle' : '']">
        <div class="row">
            <div class="d-flex align-items-center">
                <svg v-if="!spinnerCircle" viewBox="0 0 120 15" xmlns="https://www.w3.org/2000/svg" :style="{'width': iconWidth, 'height': iconHeight}">
                    <circle cx="15" :cy="iconCy" r="15">
                        <animate attributeName="r" from="15" to="15"
                                begin="0s" dur="0.8s"
                                values="15;9;15" calcMode="linear"
                                repeatCount="indefinite" />
                        <animate attributeName="fill-opacity" from="1" to="1"
                                begin="0s" dur="0.8s"
                                values="1;.5;1" calcMode="linear"
                                repeatCount="indefinite" />
                    </circle>
                    <circle cx="60" :cy="iconCy" r="9" fill-opacity="0.3">
                        <animate attributeName="r" from="9" to="9"
                                begin="0s" dur="0.8s"
                                values="9;15;9" calcMode="linear"
                                repeatCount="indefinite" />
                        <animate attributeName="fill-opacity" from="0.5" to="0.5"
                                begin="0s" dur="0.8s"
                                values=".5;1;.5" calcMode="linear"
                                repeatCount="indefinite" />
                    </circle>
                    <circle cx="105" :cy="iconCy" r="15">
                        <animate attributeName="r" from="15" to="15"
                                begin="0s" dur="0.8s"
                                values="15;9;15" calcMode="linear"
                                repeatCount="indefinite" />
                        <animate attributeName="fill-opacity" from="1" to="1"
                                begin="0s" dur="0.8s"
                                values="1;.5;1" calcMode="linear"
                                repeatCount="indefinite" />
                    </circle>
                </svg>
                <i v-if="spinnerCircle" class="pi pi-spin pi-spinner"></i>
                <span v-if="!hideText && inline" class="text-muted inline" :style="{'font-size': fontSize, 'font-weight': fontWeight}">{{ text.length ? text : $t('labels.processing') }}</span>
            </div>
        </div>
        <div v-if="!inline" class="row">
            <span class="text-muted" v-if="!hideText" :style="{'font-size': fontSize, 'font-weight': fontWeight}">{{ text.length ? text : $t('labels.processing') }}</span>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        inline: {
            type: Boolean,
            required: false,
            default: false
        },
        text: {
            type: String,
            required: false,
            default: ''
        },
        hideText: {
            type: Boolean,
            required: false,
            default: false
        },
        iconWidth: {
            type: String,
            required: false,
            default: '40px'
        },
        iconHeight: {
            type: String,
            required: false,
            default: '40px'
        },
        fontSize: {
            type: String,
            required: false,
            default: '1rem'
        },
        fontWeight: {
            type: Number,
            required: false,
            default: 700
        },
        iconCy: {
            type: Number,
            required: false,
            default: 30
        },
        spinnerCircle: {
            type: Boolean,
            required: false,
            default: false
        }
    })
</script>

<style lang="scss" scoped>
    .spinner {
        svg {
            fill: $primary;
        }

        .inline {
            margin-top: .5rem;
            margin-left: .5rem;
        }

        &.spinner-circle {
            i.pi-spinner {
                color: $primary;
            }      

            .inline {
                margin-top: .1rem;
            }
        }
    }
</style>